const Theme = {
  logo_image_url: 'bpifrance.png',

  button_color: '#ffcd00',
  button_text_color: '#383000',
  button_radius: 2,
  button_half_border_color: '#ffcd00',

  text_font: `'Montserrat', sans-serif`,
  text_color: 'black',
  title_font: `'Montserrat', sans-serif`,
  title_weight: 400,
}

export default Theme
